import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget px-6 pt-8 pb-1" }
const _hoisted_3 = { class: "s10 mt--5-5 gap-4 flex-right" }
const _hoisted_4 = { class: "s3_mobile px-8" }
const _hoisted_5 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "font-normal mt-7 mb-4" }
const _hoisted_8 = { class: "text-xl" }
const _hoisted_9 = { class: "font-normal mb-4" }
const _hoisted_10 = { class: "font-normal mb-4" }
const _hoisted_11 = { class: "text-xl" }
const _hoisted_12 = { class: "s4_mobile px-2" }
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = { class: "mb-5" }
const _hoisted_15 = {
  key: 0,
  class: "font-normal mt-5 mb-4"
}
const _hoisted_16 = { class: "text-xl" }
const _hoisted_17 = {
  key: 1,
  class: "font-normal mt-5 mb-4"
}
const _hoisted_18 = { class: "text-xl" }
const _hoisted_19 = {
  key: 2,
  class: "font-normal mb-4"
}
const _hoisted_20 = { class: "text-xl" }
const _hoisted_21 = { class: "font-normal mb-4" }
const _hoisted_22 = { class: "text-xl" }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = {
  key: 4,
  class: "font-normal mb-4"
}
const _hoisted_25 = { class: "text-xl" }
const _hoisted_26 = { class: "s13_mobile px-5" }
const _hoisted_27 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_28 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_29 = { class: "text-2xl position-absolute" }
const _hoisted_30 = { class: "font-normal mb-3" }
const _hoisted_31 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_32 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_33 = { class: "position-absolute" }
const _hoisted_34 = { class: "font-normal mb-3" }
const _hoisted_35 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_36 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_37 = { class: "position-absolute text-white" }
const _hoisted_38 = { class: "secondary-font font-semibold text-primary-color text-5xl" }
const _hoisted_39 = { class: "s20 flex items-center px-8 pb-2 gap-6" }
const _hoisted_40 = { class: "s7" }
const _hoisted_41 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_42 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_43 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_44 = { class: "s7" }
const _hoisted_45 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_46 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_47 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_48 = { class: "s6" }
const _hoisted_49 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_50 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_51 = { class: "flex items-center gap-6" }
const _hoisted_52 = { class: "s7" }
const _hoisted_53 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_54 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_55 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_56 = { class: "s7" }
const _hoisted_57 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_58 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_59 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_60 = { class: "s6" }
const _hoisted_61 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_62 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_63 = {
  key: 0,
  class: "s10 mt--5-5 gap-4 flex-right"
}
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = {
  key: 1,
  class: "s10 mt--5-5 gap-4 flex-right"
}
const _hoisted_68 = {
  key: 0,
  class: "px-5"
}
const _hoisted_69 = {
  key: 0,
  style: {"display":"flex","align-items":"center","gap":"1.5rem"}
}
const _hoisted_70 = { style: {"width":"160px","height":"160px","min-width":"160px","max-width":"160px","flex":"0 0 160px","border-radius":"15px","overflow":"hidden"} }
const _hoisted_71 = ["src"]
const _hoisted_72 = { style: {"flex":"1 1 auto","min-width":"0"} }
const _hoisted_73 = { class: "mb-2" }
const _hoisted_74 = { class: "text-xl" }
const _hoisted_75 = { class: "text-xl" }
const _hoisted_76 = {
  key: 0,
  class: "text-xl mt-2"
}
const _hoisted_77 = {
  key: 1,
  class: "text-grey-500 text-center py-5"
}
const _hoisted_78 = {
  key: 1,
  class: "px-5"
}
const _hoisted_79 = { class: "font-medium text-primary-color my-5" }
const _hoisted_80 = { class: "form-field-floating reactive active my-3" }
const _hoisted_81 = {
  key: 0,
  class: "text-red"
}
const _hoisted_82 = { class: "form-field-floating reactive active my-3" }
const _hoisted_83 = {
  key: 1,
  class: "text-red"
}
const _hoisted_84 = { class: "form-field-floating reactive active my-3" }
const _hoisted_85 = {
  key: 2,
  class: "text-red"
}
const _hoisted_86 = { class: "form-field-floating reactive active my-3" }
const _hoisted_87 = {
  key: 3,
  class: "text-red"
}
const _hoisted_88 = { class: "form-field-floating reactive active my-3" }
const _hoisted_89 = {
  key: 4,
  class: "text-red"
}
const _hoisted_90 = { class: "form-field-floating reactive active my-3" }
const _hoisted_91 = {
  key: 5,
  class: "text-red"
}
const _hoisted_92 = {
  key: 2,
  class: "px-5 mb-3"
}
const _hoisted_93 = { class: "form-check mb-3" }
const _hoisted_94 = { class: "form-check mb-3" }
const _hoisted_95 = {
  key: 0,
  class: "form-field-floating reactive active my-3"
}
const _hoisted_96 = ["value"]
const _hoisted_97 = {
  key: 1,
  class: "text-red"
}
const _hoisted_98 = {
  key: 3,
  class: "flex-right gap-3 px-5 mt-5"
}
const _hoisted_99 = ["disabled"]
const _hoisted_100 = ["disabled"]
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { key: 1 }
const _hoisted_103 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_104 = { class: "table separator skin3 selection rounded" }
const _hoisted_105 = { key: 0 }
const _hoisted_106 = { key: 1 }
const _hoisted_107 = { class: "selection-item" }
const _hoisted_108 = ["for"]
const _hoisted_109 = ["id", "value"]
const _hoisted_110 = { class: "flex" }
const _hoisted_111 = {
  class: "square-xl rounded-15",
  style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
}
const _hoisted_112 = ["src"]
const _hoisted_113 = {
  key: 0,
  class: "square-xl rounded-15 ml-3 px-3 py-3",
  style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
}
const _hoisted_114 = ["src"]
const _hoisted_115 = { style: {"width":"20%"} }
const _hoisted_116 = { class: "text-xl font-semibold mb-2" }
const _hoisted_117 = {
  key: 0,
  class: "tag-state warning stroke"
}
const _hoisted_118 = {
  key: 1,
  class: "tag-state notif stroke"
}
const _hoisted_119 = {
  key: 0,
  class: "tag-state success stroke ml-2"
}
const _hoisted_120 = { class: "text-3xl" }
const _hoisted_121 = { class: "mt-1" }
const _hoisted_122 = { class: "flex-right gap-4" }
const _hoisted_123 = ["onClick", "disabled", "title"]
const _hoisted_124 = {
  key: 0,
  class: "btn-loading"
}
const _hoisted_125 = {
  key: 0,
  class: "btn white2 active"
}
const _hoisted_126 = ["onClick", "disabled"]
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { key: 1 }
const _hoisted_129 = {
  key: 1,
  style: {"display":"flex","flex-direction":"row","justify-content":"center"}
}

import { inject, ref, computed, onMounted, reactive, toRaw } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import axios from 'axios';
    import ImportMembresComponent from './@components/ImportMembresComponent.vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import ToastNotification from '@/components/ToastNotification.vue';
    import CustomPagination from '@/components/CustomPagination.vue';
    import { formatAmount, formatDate } from '@/utils';


    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesDetailsView',
  setup(__props) {

    const route = useRoute();
    const router = useRouter();
    const BACKEND_URL = inject('BACKEND_URL');
    const collectivite = ref<any>(route.meta.item || {});
    const refreshMembers = ref(0);
    const usersCount = ref(0);
    const membersList = ref<any[]>([]);
    const loading = ref(false);
    const loadingMembers = ref(false);
    const loadingInvitations = ref(false);
    const toastMessage = ref('');
    const toastType = ref<'success' | 'error' | 'info' | 'warning'>('success');
    const showToast = ref(false);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const loadingPromoteGerant = ref<{[key: number]: boolean}>({});
    const loadingSendInvitation = ref<{[key: number]: boolean}>({});
    const activeTab = ref('information');
    const selectedMembers = ref<number[]>([]);
    const currentUser = ref<any>(null);

    // Gérant
    const gerantMode = ref<'view' | 'edit' | 'replace'>('view');
    const gerantReplaceMode = ref<'existing' | 'new'>('new');
    const gerantFormData = reactive({
        nom: '',
        prenom: '',
        telephone: '',
        email: '',
        date_naissance: '' as string | null,
        age: 0,
    });
    const gerantReplaceExistingId = ref<number | null>(null);
    const availableUsersForGerant = ref<any[]>([]);
    const loadingGerantAction = ref(false);
    const loadingResendInvitation = ref(false);
    const gerantErrors = ref<Record<string, string[]>>({});

    // États collapsables des sections
    const isCollectiviteOpen = ref(true);
    const isWalletOpen = ref(true);
    const isGerantSectionOpen = ref(true);
    const isMembresOpen = ref(true);

    // Pagination pour les membres
    const membersPagination = reactive({
        pageNumber: 1,
        total: 0,
        per_page: 10,
        last_page: 1
    });

    const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

    function formatDateFrench(dateString: string | null): string {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        return `${date.getDate()} ${monthsFr[date.getMonth()]} ${date.getFullYear()}`;
    }

    function formatAmountFr(amount: number | null | undefined): string {
        if (amount === null || amount === undefined) return '0 F';
        return new Intl.NumberFormat('fr-FR').format(amount) + ' F';
    }

    function calculatePercentage(value: number | null, total: number | null): number {
        if (!value || !total || total === 0) return 0;
        return Math.round((value / total) * 100 * 10) / 10;
    }

    async function fetchCollectiviteDetails() {
        if (!collectivite.value.id) return;
        try {
            loading.value = true;
            const response = await axios.get(`/backoffice/collectivites/get/${collectivite.value.id}`);
            collectivite.value = response.data;
        } catch (error: any) {
            console.error("Erreur lors du chargement de la collectivité:", error);
        } finally {
            loading.value = false;
        }
    }

    async function fetchUsersCount() {
        if (!collectivite.value.id) return;
        try {
            const response = await axios.get(`/backoffice/users/list?collectivite_id=${collectivite.value.id}&pageSize=1`);
            usersCount.value = response.data.total || 0;
        } catch (error: any) {
            console.error("Erreur lors du chargement du nombre de membres:", error);
        }
    }

    async function fetchMembers() {
        if (!collectivite.value.id) return;
        try {
            loadingMembers.value = true;
            const response = await axios.get(`/backoffice/users/list?collectivite_id=${collectivite.value.id}&pageSize=${membersPagination.per_page}&pageNumber=${membersPagination.pageNumber}&verified=1`);
            membersList.value = response.data.data || [];
            membersPagination.total = response.data.total || 0;
            membersPagination.last_page = response.data.last_page || 1;
        } catch (error: any) {
            console.error("Erreur lors du chargement des membres:", error);
        } finally {
            loadingMembers.value = false;
        }
    }

    onMounted(async () => {
        fetchCollectiviteDetails();
        fetchUsersCount();
        fetchMembers();

        // Récupérer les informations de l'utilisateur connecté
        try {
            const response = await axios.get('/backoffice/auth/user');
            currentUser.value = response.data;
        } catch (error) {
            console.error("Erreur lors de la récupération de l'utilisateur:", error);
        }
    });

    function onMembersImported() {
        refreshMembers.value++;
        fetchCollectiviteDetails();
        fetchUsersCount();
        fetchMembers();
    }

    function onMembersPaginate(pageNumber: number) {
        membersPagination.pageNumber = pageNumber;
        fetchMembers();
    }

    async function downloadCsv() {
        try {
            const response = await axios.get("/backoffice/collectivites/membres/download_csv_template", { responseType: "blob" });
            const blob = new Blob([response.data], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "collectivite_membres_template.csv");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Erreur de téléchargement :", error);
        }
    }

    async function sendInvitationsUnverified(memberId: number) {
        const confirmation = await confirmationModalRef.value?.open(
            "Confirmer l'envoi des invitations",
            `Voulez-vous vraiment envoyer une invitation au membre sélectionné ?`
        );
        if (confirmation) {
            loadingSendInvitation.value[memberId] = true;
            try {
                const response = await axios.post('/backoffice/collectivites/membres/send_invitations_unverified', {
                    users_ids: [memberId],
                    collectivite_id: collectivite.value.id
                });
                toastMessage.value = 'Invitation envoyée avec succès';
                toastType.value = 'success';
                showToast.value = true;
            } catch (error: any) {
                console.error("Erreur lors de l'envoi de l'invitation:", error);
                toastMessage.value = error.response?.data?.message || "Une erreur est survenue lors de l'envoi de l'invitation";
                toastType.value = 'error';
                showToast.value = true;
            } finally {
                loadingSendInvitation.value[memberId] = false;
            }
        }
    }

    async function promoteGerant(member: any) {
        if (!collectivite.value.id || !member.id) return;

        try {
            const confirmation = await confirmationModalRef.value?.open(
                "Promouvoir en gérant",
                `Voulez-vous vraiment promouvoir ${member.nom} ${member.prenom} en tant que gérant de cette collectivité ?`
            );

            if (!confirmation) {
                return;
            }

            loadingPromoteGerant.value[member.id] = true;

            const response = await axios.post('/backoffice/collectivites/membres/promote_gerant', {
                user_id: member.id,
                collectivite_id: collectivite.value.id
            });

            toastMessage.value = response.data.message || 'Membre promu gérant avec succès';
            toastType.value = 'success';
            showToast.value = true;

            // Rafraîchir la liste des membres
            setTimeout(() => {
                fetchMembers();
            }, 1000);
        } catch (error: any) {
            console.error("Erreur lors de la promotion du gérant:", error);
            toastMessage.value = error.response?.data?.message || "Une erreur est survenue lors de la promotion";
            toastType.value = 'error';
            showToast.value = true;
        } finally {
            loadingPromoteGerant.value[member.id] = false;
        }
    }

    // ----- Gérant : édition / remplacement -----

    function getGerantPhotoUrl(gerant: any): string {
        if (!gerant) return '/assets/users_avatar/600w/user.jpg';
        return gerant.photo_url || gerant.avatar_url || '/assets/users_avatar/600w/user.jpg';
    }

    function resetGerantForm(prefillFrom: any = null) {
        gerantErrors.value = {};
        gerantFormData.nom = prefillFrom?.nom ?? '';
        gerantFormData.prenom = prefillFrom?.prenom ?? '';
        gerantFormData.telephone = prefillFrom?.telephone ?? '';
        gerantFormData.email = prefillFrom?.email ?? '';
        gerantFormData.date_naissance = prefillFrom?.date_naissance ? String(prefillFrom.date_naissance).substring(0, 10) : '';
        gerantFormData.age = prefillFrom?.age ?? 0;
    }

    function recomputeAge() {
        if (!gerantFormData.date_naissance) {
            gerantFormData.age = 0;
            return;
        }
        const dob = new Date(gerantFormData.date_naissance);
        if (isNaN(dob.getTime())) return;
        const now = new Date();
        let age = now.getFullYear() - dob.getFullYear();
        const m = now.getMonth() - dob.getMonth();
        if (m < 0 || (m === 0 && now.getDate() < dob.getDate())) age--;
        gerantFormData.age = age;
    }

    function startGerantEdit() {
        resetGerantForm(collectivite.value.current_gerant);
        gerantMode.value = 'edit';
    }

    async function startGerantReplace() {
        resetGerantForm();
        gerantReplaceMode.value = 'new';
        gerantReplaceExistingId.value = null;
        gerantMode.value = 'replace';

        // Charger les candidats éligibles : membres de cette collectivité (non-gérants)
        // + users sans collectivité. Le backend filtre déjà les gérants existants.
        try {
            const response = await axios.get(`/backoffice/collectivites/${collectivite.value.id}/eligible_gerants`);
            availableUsersForGerant.value = response.data || [];
        } catch (error) {
            console.error("Erreur chargement candidats gérant:", error);
            availableUsersForGerant.value = [];
        }
    }

    function cancelGerantAction() {
        gerantMode.value = 'view';
        gerantErrors.value = {};
    }

    async function resendGerantInvitation() {
        if (!collectivite.value.id) return;
        loadingResendInvitation.value = true;
        try {
            const response = await axios.post(`/backoffice/collectivites/${collectivite.value.id}/gerant/resend-invitation`);
            toastMessage.value = response.data?.message || "Invitation renvoyée avec succès";
            toastType.value = 'success';
            showToast.value = true;
        } catch (error: any) {
            toastMessage.value = error.response?.data?.message || "Erreur lors du renvoi de l'invitation";
            toastType.value = 'error';
            showToast.value = true;
        } finally {
            loadingResendInvitation.value = false;
        }
    }

    async function submitGerantEdit() {
        if (!collectivite.value.id) return;
        loadingGerantAction.value = true;
        gerantErrors.value = {};
        try {
            const response = await axios.put(`/backoffice/collectivites/${collectivite.value.id}/gerant`, gerantFormData);
            toastMessage.value = 'Gérant modifié avec succès';
            toastType.value = 'success';
            showToast.value = true;
            gerantMode.value = 'view';
            await fetchCollectiviteDetails();
        } catch (error: any) {
            if (error.response?.status === 422 && error.response?.data?.errors) {
                gerantErrors.value = error.response.data.errors;
            }
            toastMessage.value = error.response?.data?.message || "Erreur lors de la modification du gérant";
            toastType.value = 'error';
            showToast.value = true;
        } finally {
            loadingGerantAction.value = false;
        }
    }

    async function submitGerantReplace() {
        if (!collectivite.value.id) return;

        const confirmation = await confirmationModalRef.value?.open(
            "Changer de gérant",
            "Voulez-vous vraiment remplacer le gérant actuel ? L'ancien gérant sera retiré de cette collectivité."
        );
        if (!confirmation) return;

        loadingGerantAction.value = true;
        gerantErrors.value = {};
        try {
            const payload: any = {};
            if (gerantReplaceMode.value === 'existing') {
                if (!gerantReplaceExistingId.value) {
                    gerantErrors.value = { gerant_id: ['Veuillez sélectionner un utilisateur'] };
                    loadingGerantAction.value = false;
                    return;
                }
                payload.gerant_id = gerantReplaceExistingId.value;
            } else {
                payload.gerant = { ...gerantFormData };
            }

            const response = await axios.post(`/backoffice/collectivites/${collectivite.value.id}/gerant/replace`, payload);
            toastMessage.value = 'Gérant remplacé avec succès';
            toastType.value = 'success';
            showToast.value = true;
            gerantMode.value = 'view';
            await fetchCollectiviteDetails();
            fetchMembers();
        } catch (error: any) {
            if (error.response?.status === 422 && error.response?.data?.errors) {
                gerantErrors.value = error.response.data.errors;
            }
            toastMessage.value = error.response?.data?.message || "Erreur lors du remplacement du gérant";
            toastType.value = 'error';
            showToast.value = true;
        } finally {
            loadingGerantAction.value = false;
        }
    }

    function getStatusTags(item: any) {
        const tags = [];
        if (item.email_verified_at) {
            tags.push({ label: 'Authentification', type: 'success' });
        } else {
            tags.push({ label: 'Authentification', type: 'warning' });
        }

        if (item.souscription_id) {
            tags.push({ label: 'Souscription', type: 'success' });
        } else {
            tags.push({ label: 'Souscription', type: 'warning' });
        }

        if (item.code_securite) {
            tags.push({ label: 'Code de sécurité', type: 'success' });
        } else {
            tags.push({ label: 'Code de sécurité', type: 'warning' });
        }

        if (item.actif) {
            tags.push({ label: 'Connecter', type: 'success' });
        } else {
            tags.push({ label: 'Connecter', type: 'warning' });
        }

        return tags;
    }

    function goToEdit() {
        router.push(`/app/collectivites/form/${collectivite.value.id}`);
    }

    function goToOnboarding() {
        router.push(`/app/collectivites/onboarding-groupe/${collectivite.value.id}`);
    }

    function goToPrelevements() {
        router.push(`/app/collectivites/${collectivite.value.id}/prelevements`);
    }

    // Vérifier si l'utilisateur est gérant de cette collectivité
    const isGerant = computed(() => {
        if (!currentUser.value || !collectivite.value.id) return false;

        // Vérifier si l'utilisateur est gérant via la table pivot user_collectivites
        const userCollectivites = currentUser.value.collectivites || [];
        const collectiviteGeree = userCollectivites.find(
            (c: any) => c.id === collectivite.value.id && c.pivot?.is_gerant === true
        );

        return !!collectiviteGeree;
    });

    // Computed pour les statistiques
    const stats = computed(() => collectivite.value.stats || {});

    const membersPercentage = computed(() => {
        const maxMembers = 50000; // Valeur par défaut pour la barre de progression
        return Math.min(100, calculatePercentage(stats.value.members_count, maxMembers));
    });

    const prelevementPercentage = computed(() => {
        const current = stats.value.current_prelevement;
        if (!current) return 0;
        return calculatePercentage(current.montant_prelevement, current.montant_prelevement_expected);
    });

    const decaissementPercentage = computed(() => {
        const current = stats.value.current_decaissement;
        if (!current) return 0;
        return calculatePercentage(current.montant_decaissement, current.montant_decaissement_expected);
    });

    const activeBalancePercentage = computed(() => {
        return calculatePercentage(stats.value.active_balance, stats.value.total_balance);
    });

    const blockedBalancePercentage = computed(() => {
        return calculatePercentage(stats.value.blocked_balance, stats.value.total_balance);
    });

    const walletSolde = computed(() => {
        const totalPrelevements = stats.value.total_prelevements || 0;
        const totalDecaissements = stats.value.total_decaissements || 0;
        return totalPrelevements - totalDecaissements;
    });

    const walletSoldePercentage = computed(() => {
        const totalPrelevements = stats.value.total_prelevements || 0;
        if (totalPrelevements === 0) return 0;
        return calculatePercentage(walletSolde.value, totalPrelevements);
    });

    const decaissementTotalPercentage = computed(() => {
        const totalPrelevements = stats.value.total_prelevements || 0;
        if (totalPrelevements === 0) return 0;
        return calculatePercentage(stats.value.total_decaissements, totalPrelevements);
    });


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[86] || (_cache[86] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Collectivités / Détails <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Informations</span><span class=\"btn shadow-200 white2\">Wallet / Décaissement</span><span class=\"btn shadow-200 white2\">Gérant</span><span class=\"btn shadow-200 white2\">Membres</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["s10 mt--4 ml--4 mb-5 collapse-open", { 'active': isCollectiviteOpen.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isCollectiviteOpen.value = !isCollectiviteOpen.value)),
        style: {"cursor":"pointer"}
      }, [...(_cache[17] || (_cache[17] = [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Collectivité ")
        ], -1)
      ]))], 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn lg py-3 white2 active",
          onClick: _withModifiers(goToEdit, ["stop"])
        }, [...(_cache[18] || (_cache[18] = [
          _createElementVNode("img", {
            src: "/icons/icon-edit.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "Editer", -1)
        ]))]),
        _createElementVNode("button", {
          class: "btn lg py-3 white2 active",
          onClick: _withModifiers(goToOnboarding, ["stop"])
        }, [...(_cache[19] || (_cache[19] = [
          _createElementVNode("img", {
            src: "/icons/icon-consulter.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "Onboarding", -1)
        ]))]),
        _createElementVNode("button", {
          class: "btn lg py-3 white2 active",
          onClick: _withModifiers(goToPrelevements, ["stop"])
        }, [...(_cache[20] || (_cache[20] = [
          _createElementVNode("img", {
            src: "/icons/icon-consulter.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "Prélèvements / Décaissements", -1)
        ]))])
      ]),
      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["s20 collapse-content pt-5 pb-8", { 'active': isCollectiviteOpen.value }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: collectivite.value.logo ? (_unref(BACKEND_URL) + '/assets/collectivites/' + collectivite.value.logo) : '/assets/logos/logo2.svg',
              width: "100%"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("h6", _hoisted_7, [
            _createElementVNode("b", _hoisted_8, _toDisplayString(collectivite.value.pays?.nom || 'Côte d\'Ivoire') + " | " + _toDisplayString(Array.isArray(collectivite.value.secteurs) ? collectivite.value.secteurs.join(', ') : (collectivite.value.secteurs || 'N/A')), 1)
          ]),
          _createElementVNode("h6", _hoisted_9, [
            _createTextVNode(_toDisplayString(collectivite.value.telephone || '') + " " + _toDisplayString(collectivite.value.email ? '| ' + collectivite.value.email : ''), 1),
            _cache[21] || (_cache[21] = _createElementVNode("br", { class: "mb-2" }, null, -1))
          ]),
          _createElementVNode("h6", _hoisted_10, [
            _cache[22] || (_cache[22] = _createTextVNode(" Adresse ", -1)),
            _cache[23] || (_cache[23] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
            _createElementVNode("b", _hoisted_11, _toDisplayString(collectivite.value.adresse || 'N/A'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h3", _hoisted_13, _toDisplayString(collectivite.value.nom || ''), 1),
          _createElementVNode("h4", _hoisted_14, _toDisplayString(collectivite.value.rccm || 'N/A'), 1),
          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1)),
          (collectivite.value.date_souscription)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_15, [
                _cache[24] || (_cache[24] = _createTextVNode(" Date de souscription ", -1)),
                _cache[25] || (_cache[25] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_16, _toDisplayString(formatDateFrench(collectivite.value.date_souscription)), 1)
              ]))
            : _createCommentVNode("", true),
          (collectivite.value.date_creation || collectivite.value.created_at)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_17, [
                _cache[26] || (_cache[26] = _createTextVNode(" Date de création ", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_18, _toDisplayString(formatDateFrench(collectivite.value.date_creation || collectivite.value.created_at)), 1)
              ]))
            : _createCommentVNode("", true),
          (collectivite.value.rccm)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_19, [
                _cache[28] || (_cache[28] = _createTextVNode(" Numero d'immatriculation ", -1)),
                _cache[29] || (_cache[29] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_20, _toDisplayString(collectivite.value.rccm), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("h6", _hoisted_21, [
            _cache[30] || (_cache[30] = _createTextVNode(" Adresse ", -1)),
            _cache[31] || (_cache[31] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
            _createElementVNode("b", _hoisted_22, _toDisplayString(collectivite.value.adresse || 'N/A'), 1)
          ]),
          (collectivite.value.justificatif)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_23))
            : _createCommentVNode("", true),
          (collectivite.value.justificatif)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_24, [
                _cache[32] || (_cache[32] = _createTextVNode(" Justificatif ", -1)),
                _cache[33] || (_cache[33] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_25, _toDisplayString(collectivite.value.justificatif), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, "Membres " + _toDisplayString(stats.value.members_count ? Math.round((stats.value.members_count / 50000) * 100) : 0) + "%", 1),
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
              style: _normalizeStyle({ width: membersPercentage.value + '%' })
            }, [
              _createElementVNode("div", _hoisted_29, _toDisplayString(stats.value.members_count || 0) + " / 50000", 1)
            ], 4)
          ]),
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1)),
          _createElementVNode("h3", _hoisted_30, "Prélèvement de " + _toDisplayString(stats.value.current_month_label || 'Janvier 2026'), 1),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, _toDisplayString(prelevementPercentage.value) + "%", 1),
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 px-7 bg-pop-green",
              style: _normalizeStyle({ width: prelevementPercentage.value + '%' })
            }, [
              _createElementVNode("h2", _hoisted_33, _toDisplayString(formatAmountFr(stats.value.current_prelevement?.montant_prelevement)) + " / " + _toDisplayString(formatAmountFr(stats.value.current_prelevement?.montant_prelevement_expected || 1000000)), 1)
            ], 4)
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1)),
          _createElementVNode("h3", _hoisted_34, "Décaissement de " + _toDisplayString(stats.value.current_month_label || 'Janvier 2026'), 1),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, _toDisplayString(decaissementPercentage.value) + "%", 1),
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 px-7 bg-color-1000",
              style: _normalizeStyle({ width: decaissementPercentage.value + '%' })
            }, [
              _createElementVNode("h2", _hoisted_37, _toDisplayString(formatAmountFr(stats.value.current_decaissement?.montant_decaissement)) + " / " + _toDisplayString(formatAmountFr(stats.value.current_decaissement?.montant_decaissement_expected || 1000000)), 1)
            ], 4)
          ]),
          _cache[37] || (_cache[37] = _createElementVNode("h5", { class: "secondary-font font-semibold text-primary-color mt-5" }, " Taux de financement ", -1)),
          _createElementVNode("h1", _hoisted_38, _toDisplayString(collectivite.value.profil?.taux_interet || 0) + "%", 1)
        ]),
        _cache[43] || (_cache[43] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
        _cache[44] || (_cache[44] = _createElementVNode("hr", { class: "mb-8" }, null, -1)),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _cache[38] || (_cache[38] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
              _createTextVNode(" Débloqué ")
            ], -1)),
            _createElementVNode("h1", _hoisted_41, _toDisplayString(formatAmountFr(stats.value.active_balance)), 1),
            _createElementVNode("h5", _hoisted_42, _toDisplayString(activeBalancePercentage.value) + "%", 1),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
                style: _normalizeStyle({ width: Math.max(activeBalancePercentage.value, 5) + '%' })
              }, _toDisplayString(activeBalancePercentage.value) + "% ", 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _cache[39] || (_cache[39] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-purple" }),
              _createTextVNode(" Bloqué ")
            ], -1)),
            _createElementVNode("h1", _hoisted_45, _toDisplayString(formatAmountFr(stats.value.blocked_balance)), 1),
            _createElementVNode("h5", _hoisted_46, _toDisplayString(blockedBalancePercentage.value) + "%", 1),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white",
                style: _normalizeStyle({ width: Math.max(blockedBalancePercentage.value, 5) + '%' })
              }, _toDisplayString(blockedBalancePercentage.value) + "% ", 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _cache[40] || (_cache[40] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-green-light" }),
              _createTextVNode(" Total ")
            ], -1)),
            _createElementVNode("h1", _hoisted_49, _toDisplayString(formatAmountFr(stats.value.total_balance)), 1),
            _cache[41] || (_cache[41] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "100%", -1)),
            _cache[42] || (_cache[42] = _createElementVNode("div", {
              class: "h-40 rounded-100 position-relative overflow-hidden",
              style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
            }, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                style: {"width":"100%"}
              }, " 100% ")
            ], -1))
          ])
        ])
      ], 2), [
        [_vShow, isCollectiviteOpen.value]
      ])
    ]),
    _cache[87] || (_cache[87] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[88] || (_cache[88] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[89] || (_cache[89] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_50, [
      _createElementVNode("div", {
        class: _normalizeClass(["s10 mt--4 ml--4 mb-5 collapse-open", { 'active': isWalletOpen.value }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (isWalletOpen.value = !isWalletOpen.value)),
        style: {"cursor":"pointer"}
      }, [...(_cache[46] || (_cache[46] = [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Wallet / Décaissement ")
        ], -1)
      ]))], 2),
      _cache[53] || (_cache[53] = _createElementVNode("div", { class: "s10 mt--5-5 flex-right" }, null, -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["s20 gap-6 px-5 pb-8 collapse-content", { 'active': isWalletOpen.value }])
      }, [
        _cache[52] || (_cache[52] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _cache[47] || (_cache[47] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-color-black" }),
              _createTextVNode(" Solde ")
            ], -1)),
            _createElementVNode("h1", _hoisted_53, _toDisplayString(formatAmountFr(walletSolde.value)), 1),
            _createElementVNode("h5", _hoisted_54, _toDisplayString(walletSoldePercentage.value) + "%", 1),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-black",
                style: _normalizeStyle({ width: Math.max(walletSoldePercentage.value, 5) + '%' })
              }, _toDisplayString(walletSoldePercentage.value) + "% ", 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _cache[48] || (_cache[48] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
              _createTextVNode(" Montant Décaissé ")
            ], -1)),
            _createElementVNode("h1", _hoisted_57, _toDisplayString(formatAmountFr(stats.value.total_decaissements)), 1),
            _createElementVNode("h5", _hoisted_58, _toDisplayString(decaissementTotalPercentage.value) + "%", 1),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
                style: _normalizeStyle({ width: Math.max(decaissementTotalPercentage.value, 5) + '%' })
              }, _toDisplayString(decaissementTotalPercentage.value) + "% ", 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _cache[49] || (_cache[49] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-green-light" }),
              _createTextVNode(" Dernier décaissement ")
            ], -1)),
            _createElementVNode("h1", _hoisted_61, _toDisplayString(formatAmountFr(stats.value.last_decaissement?.montant_decaissement)), 1),
            _cache[50] || (_cache[50] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "100%", -1)),
            _cache[51] || (_cache[51] = _createElementVNode("div", {
              class: "h-40 rounded-100 position-relative overflow-hidden",
              style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
            }, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                style: {"width":"100%"}
              }, " 100% ")
            ], -1))
          ])
        ])
      ], 2), [
        [_vShow, isWalletOpen.value]
      ])
    ]),
    _cache[90] || (_cache[90] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[91] || (_cache[91] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[92] || (_cache[92] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", {
        class: _normalizeClass(["s10 mt--4 ml--4 mb-5 collapse-open", { 'active': isGerantSectionOpen.value }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (isGerantSectionOpen.value = !isGerantSectionOpen.value)),
        style: {"cursor":"pointer"}
      }, [...(_cache[54] || (_cache[54] = [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Gérant ")
        ], -1)
      ]))], 2),
      (gerantMode.value === 'view' && collectivite.value.current_gerant)
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            (!collectivite.value.current_gerant.last_connnection_at)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn lg py-3 white2 active",
                  disabled: loadingResendInvitation.value,
                  onClick: _withModifiers(resendGerantInvitation, ["stop"])
                }, [
                  _cache[55] || (_cache[55] = _createElementVNode("img", {
                    src: "/icons/icon-send.svg",
                    class: "btn-icon",
                    alt: ""
                  }, null, -1)),
                  (!loadingResendInvitation.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Renvoyer l'invitation"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_66, "Envoi en cours..."))
                ], 8, _hoisted_64))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn lg py-3 white2 active",
              onClick: _withModifiers(startGerantEdit, ["stop"])
            }, [...(_cache[56] || (_cache[56] = [
              _createElementVNode("img", {
                src: "/icons/icon-edit.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Modifier", -1)
            ]))]),
            _createElementVNode("button", {
              class: "btn lg py-3 white2 active",
              onClick: _withModifiers(startGerantReplace, ["stop"])
            }, [...(_cache[57] || (_cache[57] = [
              _createElementVNode("img", {
                src: "/icons/icon-actif.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Changer de gérant", -1)
            ]))])
          ]))
        : (gerantMode.value === 'view' && !collectivite.value.current_gerant)
          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
              _createElementVNode("button", {
                class: "btn lg py-3 white2 active",
                onClick: _withModifiers(startGerantReplace, ["stop"])
              }, [...(_cache[58] || (_cache[58] = [
                _createElementVNode("img", {
                  src: "/icons/icon-actif.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Désigner un gérant", -1)
              ]))])
            ]))
          : _createCommentVNode("", true),
      _cache[69] || (_cache[69] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["s20 collapse-content pt-3 pb-6", { 'active': isGerantSectionOpen.value }])
      }, [
        (gerantMode.value === 'view')
          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
              (collectivite.value.current_gerant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("img", {
                        src: getGerantPhotoUrl(collectivite.value.current_gerant),
                        style: {"width":"160px","height":"160px","object-fit":"cover","display":"block"}
                      }, null, 8, _hoisted_71)
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("h3", _hoisted_73, _toDisplayString(collectivite.value.current_gerant.nom) + " " + _toDisplayString(collectivite.value.current_gerant.prenom), 1),
                      _createElementVNode("p", _hoisted_74, _toDisplayString(collectivite.value.current_gerant.email), 1),
                      _createElementVNode("p", _hoisted_75, _toDisplayString(collectivite.value.current_gerant.telephone), 1),
                      (collectivite.value.current_gerant.fonction)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_76, _toDisplayString(collectivite.value.current_gerant.fonction), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_77, " Aucun gérant désigné pour cette collectivité. "))
            ]))
          : _createCommentVNode("", true),
        (gerantMode.value === 'edit' || (gerantMode.value === 'replace' && gerantReplaceMode.value === 'new'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
              _createElementVNode("h2", _hoisted_79, _toDisplayString(gerantMode.value === 'edit' ? 'Modifier les infos du gérant' : 'Nouveau gérant'), 1),
              _createElementVNode("div", _hoisted_80, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-input",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((gerantFormData.nom) = $event)),
                  placeholder: "Nom"
                }, null, 512), [
                  [_vModelText, gerantFormData.nom]
                ]),
                _cache[59] || (_cache[59] = _createElementVNode("label", null, [
                  _createTextVNode("Nom "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ]),
              (gerantErrors.value.nom || gerantErrors.value['gerant.nom'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString((gerantErrors.value.nom || gerantErrors.value['gerant.nom'])?.[0]), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_82, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-input",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((gerantFormData.prenom) = $event)),
                  placeholder: "Prénom"
                }, null, 512), [
                  [_vModelText, gerantFormData.prenom]
                ]),
                _cache[60] || (_cache[60] = _createElementVNode("label", null, [
                  _createTextVNode("Prénom "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ]),
              (gerantErrors.value.prenom || gerantErrors.value['gerant.prenom'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString((gerantErrors.value.prenom || gerantErrors.value['gerant.prenom'])?.[0]), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_84, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-input",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((gerantFormData.telephone) = $event)),
                  placeholder: "Téléphone"
                }, null, 512), [
                  [_vModelText, gerantFormData.telephone]
                ]),
                _cache[61] || (_cache[61] = _createElementVNode("label", null, [
                  _createTextVNode("Téléphone "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ]),
              (gerantErrors.value.telephone || gerantErrors.value['gerant.telephone'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString((gerantErrors.value.telephone || gerantErrors.value['gerant.telephone'])?.[0]), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_86, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-input",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((gerantFormData.email) = $event)),
                  placeholder: "Email"
                }, null, 512), [
                  [_vModelText, gerantFormData.email]
                ]),
                _cache[62] || (_cache[62] = _createElementVNode("label", null, [
                  _createTextVNode("Email "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ]),
              (gerantErrors.value.email || gerantErrors.value['gerant.email'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString((gerantErrors.value.email || gerantErrors.value['gerant.email'])?.[0]), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_88, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-input",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((gerantFormData.date_naissance) = $event)),
                  onChange: recomputeAge
                }, null, 544), [
                  [_vModelText, gerantFormData.date_naissance]
                ]),
                _cache[63] || (_cache[63] = _createElementVNode("label", null, [
                  _createTextVNode("Date de naissance "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ]),
              (gerantErrors.value['gerant.date_naissance'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(gerantErrors.value['gerant.date_naissance']?.[0]), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_90, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "form-input",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((gerantFormData.age) = $event)),
                  readonly: ""
                }, null, 512), [
                  [
                    _vModelText,
                    gerantFormData.age,
                    void 0,
                    { number: true }
                  ]
                ]),
                _cache[64] || (_cache[64] = _createElementVNode("label", null, "Âge", -1))
              ]),
              (gerantErrors.value['gerant.age'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString(gerantErrors.value['gerant.age']?.[0]), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (gerantMode.value === 'replace')
          ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
              _createElementVNode("div", _hoisted_93, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "replace_new",
                  value: "new",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((gerantReplaceMode).value = $event))
                }, null, 512), [
                  [_vModelRadio, gerantReplaceMode.value]
                ]),
                _cache[65] || (_cache[65] = _createElementVNode("label", {
                  for: "replace_new",
                  class: "ml-2"
                }, "Créer un nouveau gérant", -1))
              ]),
              _createElementVNode("div", _hoisted_94, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "replace_existing",
                  value: "existing",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((gerantReplaceMode).value = $event))
                }, null, 512), [
                  [_vModelRadio, gerantReplaceMode.value]
                ]),
                _cache[66] || (_cache[66] = _createElementVNode("label", {
                  for: "replace_existing",
                  class: "ml-2"
                }, "Promouvoir un utilisateur existant", -1))
              ]),
              (gerantReplaceMode.value === 'existing')
                ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-input-select",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((gerantReplaceExistingId).value = $event))
                    }, [
                      _cache[67] || (_cache[67] = _createElementVNode("option", { value: null }, "— Sélectionnez un utilisateur —", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableUsersForGerant.value, (u) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: u.id,
                          value: u.id
                        }, _toDisplayString(u.fullname || (u.nom + ' ' + u.prenom)) + " (" + _toDisplayString(u.email) + ") ", 9, _hoisted_96))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, gerantReplaceExistingId.value]
                    ]),
                    _cache[68] || (_cache[68] = _createElementVNode("label", null, [
                      _createTextVNode("Utilisateur existant "),
                      _createElementVNode("b", { class: "color-danger" }, "*")
                    ], -1))
                  ]))
                : _createCommentVNode("", true),
              (gerantErrors.value.gerant_id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(gerantErrors.value.gerant_id?.[0]), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (gerantMode.value !== 'view')
          ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
              _createElementVNode("button", {
                class: "btn lg py-3 white2",
                onClick: cancelGerantAction,
                disabled: loadingGerantAction.value
              }, " Annuler ", 8, _hoisted_99),
              _createElementVNode("button", {
                class: "btn lg py-3",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (gerantMode.value === 'edit' ? submitGerantEdit() : submitGerantReplace())),
                disabled: loadingGerantAction.value
              }, [
                (!loadingGerantAction.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_101, "Enregistrer"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_102, "Enregistrement..."))
              ], 8, _hoisted_100)
            ]))
          : _createCommentVNode("", true)
      ], 2), [
        [_vShow, isGerantSectionOpen.value]
      ])
    ]),
    _cache[93] || (_cache[93] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[94] || (_cache[94] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[95] || (_cache[95] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_103, [
      _createElementVNode("div", {
        class: _normalizeClass(["s10 mt--4 ml--4 mb-5 collapse-open", { 'active': isMembresOpen.value }]),
        onClick: _cache[13] || (_cache[13] = ($event: any) => (isMembresOpen.value = !isMembresOpen.value)),
        style: {"cursor":"pointer"}
      }, [...(_cache[70] || (_cache[70] = [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Membres ")
        ], -1)
      ]))], 2),
      _cache[85] || (_cache[85] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["s20 items-center gap-6 px-0 pb-6 collapse-content", { 'active': isMembresOpen.value }])
      }, [
        (collectivite.value.id)
          ? (_openBlock(), _createBlock(ImportMembresComponent, {
              "collectivite-id": collectivite.value.id,
              key: refreshMembers.value,
              onCompleted: onMembersImported
            }, null, 8, ["collectivite-id"]))
          : _createCommentVNode("", true),
        _cache[84] || (_cache[84] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
        _createElementVNode("table", _hoisted_104, [
          _cache[83] || (_cache[83] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("label", {
                  class: "btn-circle",
                  for: "check-members-all"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    name: "check-members-all",
                    id: "check-members-all"
                  })
                ])
              ]),
              _createElementVNode("th"),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Information")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Utilisation")
              ]),
              _createElementVNode("th", { class: "flex-right" }, [
                _createElementVNode("button", { class: "btn-ultra color2" }, [
                  _createElementVNode("div", { class: "btn-show" }, [
                    _createElementVNode("img", {
                      src: "/icons/icon-actif.svg",
                      class: "btn-icon",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Actif")
                  ]),
                  _createElementVNode("div", { class: "btn-loading" }, [
                    _createElementVNode("div", { class: "loader-dots" })
                  ])
                ])
              ])
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (loadingMembers.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_105, [...(_cache[71] || (_cache[71] = [
                  _createElementVNode("td", {
                    colspan: "5",
                    class: "text-center text-grey-500 py-5"
                  }, [
                    _createElementVNode("div", { class: "loader dark" })
                  ], -1)
                ]))]))
              : (membersList.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_106, [...(_cache[72] || (_cache[72] = [
                    _createElementVNode("td", {
                      colspan: "5",
                      class: "text-center text-grey-500 py-5"
                    }, " Aucun membre trouvé ", -1)
                  ]))]))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(membersList.value, (member, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "text-grey-700 over-effect",
                key: 'member_' + index
              }, [
                _createElementVNode("td", _hoisted_107, [
                  _createElementVNode("label", {
                    class: "btn-circle",
                    for: 'member_check_' + index
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      name: "selectedMembers[]",
                      id: 'member_check_' + index,
                      value: member.id,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((selectedMembers).value = $event))
                    }, null, 8, _hoisted_109), [
                      [_vModelCheckbox, selectedMembers.value]
                    ])
                  ], 8, _hoisted_108)
                ]),
                _createElementVNode("td", _hoisted_110, [
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("img", {
                      src: !!member.photo_url ? member.photo_url : '/assets/users_avatar/600w/user.jpg',
                      width: "100%"
                    }, null, 8, _hoisted_112)
                  ]),
                  (collectivite.value.logo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                        _createElementVNode("img", {
                          src: _unref(BACKEND_URL) + '/assets/collectivites/' + collectivite.value.logo,
                          width: "100%"
                        }, null, 8, _hoisted_114)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_115, [
                  _createElementVNode("p", _hoisted_116, [
                    _createTextVNode(_toDisplayString(member.reference || 'N/A') + "   ", 1),
                    (!member.email_verified_at)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_117, "En cours"))
                      : _createCommentVNode("", true),
                    (member.actif)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_118, "Actif"))
                      : _createCommentVNode("", true)
                  ]),
                  _createTextVNode(" " + _toDisplayString(member.nom + ' ' + member.prenom) + " - " + _toDisplayString(member.collectivite?.nom || collectivite.value.nom) + " ", 1),
                  (member.is_gerant)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_119, "Gérant"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_120, [
                  _createTextVNode(_toDisplayString(member.quotite_cessible_pourcent ? member.quotite_cessible_pourcent + '%' : '-') + " ", 1),
                  _createElementVNode("p", _hoisted_121, _toDisplayString(member.quotite_cessible_montant ? formatAmountFr(member.quotite_cessible_montant) : '-'), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_122, [
                    _createVNode(_component_router_link, {
                      to: '/app/users/form/' + member.id
                    }, {
                      default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                        _createElementVNode("button", { class: "btn tips" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-edit.svg",
                            class: "btn-icon",
                            alt: ""
                          })
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (promoteGerant(member)),
                      class: "btn-ultra color2 tips",
                      disabled: loadingPromoteGerant.value[member.id] || member.is_gerant,
                      title: member.is_gerant ? 'Déjà gérant' : 'Promouvoir en gérant'
                    }, [
                      _cache[75] || (_cache[75] = _createElementVNode("div", { class: "btn-show" }, [
                        _createElementVNode("img", {
                          src: "/icons/icon-actif.svg",
                          class: "btn-icon",
                          alt: ""
                        })
                      ], -1)),
                      (loadingPromoteGerant.value[member.id])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_124, [...(_cache[74] || (_cache[74] = [
                            _createElementVNode("div", { class: "loader-dots" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_123),
                    (member.can_receive_invitation_link == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_125, [...(_cache[76] || (_cache[76] = [
                          _createElementVNode("img", {
                            src: "/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }, null, -1),
                          _createElementVNode("span", null, "Envoyer lien d'invitation", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (member.can_receive_invitation_link == true)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          onClick: ($event: any) => (sendInvitationsUnverified(member.id)),
                          class: "btn normal ml-3 justify-content-center btn-filtre",
                          disabled: loadingSendInvitation.value[member.id]
                        }, [
                          _cache[77] || (_cache[77] = _createElementVNode("img", {
                            src: "/icons/icon-send.svg",
                            class: "btn-icon",
                            alt: ""
                          }, null, -1)),
                          (!loadingSendInvitation.value[member.id])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_127, "Envoyer invitation"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_128, "Envoi..."))
                        ], 8, _hoisted_126))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      to: '/app/users/' + member.id + '/details'
                    }, {
                      default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Gérer")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      to: '/app/users/' + member.id + '/carte'
                    }, {
                      default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Carte")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      to: '/app/users/' + member.id + '/utilisation'
                    }, {
                      default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Utilisation")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      to: '/app/users/' + member.id + '/plan'
                    }, {
                      default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Plan")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      to: '/app/users/' + member.id + '/revolving'
                    }, {
                      default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                        _createElementVNode("button", { class: "btn white2 active" }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-consulter.svg",
                            class: "btn-icon",
                            alt: ""
                          }),
                          _createElementVNode("span", null, "Revolving")
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        (membersList.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
              _createVNode(CustomPagination, {
                modelValue: membersPagination.pageNumber,
                "onUpdate:modelValue": [
                  _cache[15] || (_cache[15] = ($event: any) => ((membersPagination.pageNumber) = $event)),
                  onMembersPaginate
                ],
                total: membersPagination.total,
                "per-page": membersPagination.per_page,
                last_page: membersPagination.last_page
              }, null, 8, ["modelValue", "total", "per-page", "last_page"])
            ]))
          : _createCommentVNode("", true)
      ], 2), [
        [_vShow, isMembresOpen.value]
      ])
    ]),
    _cache[96] || (_cache[96] = _createElementVNode("div", { class: "clear-both h-50" }, null, -1)),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512),
    _createVNode(ToastNotification, {
      message: toastMessage.value,
      type: toastType.value,
      show: showToast.value,
      "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => (showToast.value = $event))
    }, null, 8, ["message", "type", "show"])
  ]))
}
}

})